import top from '../assets/images/editor/navigation/top.gif'
import middle from '../assets/images/editor/navigation/middle.gif'
import bottom from '../assets/images/editor/navigation/bottom.gif'

import rightArrow from '../assets/images/editor/navigation/rightArrow.png'


import downArrow from '../assets/images/editor/navigation/downArrow.png'

export const tabType = {
   NORMAL: {
        FIRST: top,
        MIDDLE: middle,
        LAST: bottom
    },
    FOLDER: {
        FIRST: rightArrow,
        MIDDLE: rightArrow,
        LAST: rightArrow
    },
    OPEN_FOLDER: {
        FIRST: downArrow,
        MIDDLE: downArrow,
        LAST: downArrow
    },
    IN_FOLDER: {
        FIRST: middle,
        MIDDLE: middle,
        LAST: bottom
    }
}

export function getNavigationImageSrc(tabType) {
    return tabType; // tabType maps to image name
}